export default "__VITE_ASSET__7a7efc80__"